import { Grid, Typography } from '@mui/material';
import { TextField, DateField, SimpleShowLayout, useRecordContext } from 'react-admin';
import { OfferOrderDetails } from 'src/models';

export const OfferOrderTransferDetails = () => {
  const record = useRecordContext<OfferOrderDetails>();

  return (
    <Grid container direction='row'>
      <Grid item xs={12} sm={12} md={12}>
        <SimpleShowLayout>
          <Typography variant='h5'>Other Transfer Details</Typography>
        </SimpleShowLayout>
      </Grid>
      <Grid item xs={6} sm={6} md={6}>
        <SimpleShowLayout>
          <TextField label='Clearing Firm' source='transferDetails.clearingFirm' />
        </SimpleShowLayout>
      </Grid>
      <Grid item xs={6} sm={6} md={6}>
        <SimpleShowLayout>
          <DateField label='Statement Received At' source='transferDetails.statementReceivedAt' />
        </SimpleShowLayout>
      </Grid>
      {record.paymentType.isAcat && (
        <>
          <Grid item xs={6} sm={6} md={6}>
            <SimpleShowLayout>
              <DateField label='ACAT Sent At' source='transferDetails.acatSentAt' />
            </SimpleShowLayout>
          </Grid>
          <Grid item xs={6} sm={6} md={6}>
            <SimpleShowLayout>
              <DateField label='ACAT Received At' source='transferDetails.acatReceivedAt' />
            </SimpleShowLayout>
          </Grid>
          <Grid item xs={6} sm={6} md={6}>
            <SimpleShowLayout>
              <DateField label='ACAT Submitted At' source='transferDetails.acatSubmittedToExternalAt' />
            </SimpleShowLayout>
          </Grid>
          <Grid item xs={6} sm={6} md={6}>
            <SimpleShowLayout>
              <DateField label='ACAT Resubmitted At' source='transferDetails.acatResubmittedToExternalAt' />
            </SimpleShowLayout>
          </Grid>
        </>
      )}
      <Grid item xs={6} sm={6} md={6}>
        <SimpleShowLayout>
          <TextField label='Reject Reason' source='transferDetails.rejectReason' />
        </SimpleShowLayout>
      </Grid>
    </Grid>
  );
};
